import MedicalCenterList from "./MedicalCenterList";

export default MedicalCenterList;
